import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	PrimaryGeneratedColumn,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { EmailRecordEntity } from './email-record.entity';

export enum RecipientType {
	TO = 'to',
	CC = 'cc',
	BCC = 'bcc',
	FROM = 'from',
}

@Entity('email_recipient')
@Index(['email', 'type'])
export class EmailRecipientEntity extends BaseEntity<string> {
	@PrimaryGeneratedColumn({ name: '_id', type: 'bigint', unsigned: true })
	declare id: string;

	@Column({ name: 'fk_email_record__id', type: 'bigint', unsigned: true })
	public emailRecordId!: string;

	@ManyToOne(() => EmailRecordEntity, (record) => record.recipients)
	@JoinColumn({ name: 'fk_email_record__id' })
	public emailRecord!: EmailRecordEntity;

	@Column({ type: 'varchar', length: 320 })
	public email!: string;

	@Column({ type: 'varchar', length: 255, nullable: true })
	public name?: string;

	@Column({
		type: 'enum',
		enum: RecipientType,
	})
	public type!: RecipientType;

	@Column({ type: 'varchar', length: 50, nullable: true })
	public response?: string; // For calendar: 'accepted', 'declined', etc.
}
